import { render, staticRenderFns } from "./occuption-form.vue?vue&type=template&id=08c02746&scoped=true&"
import script from "./occuption-form.vue?vue&type=script&lang=js&"
export * from "./occuption-form.vue?vue&type=script&lang=js&"
import style0 from "./occuption-form.vue?vue&type=style&index=0&id=08c02746&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c02746",
  null
  
)

export default component.exports